import type { Component } from 'vue';
import type { DialogQueueOptions } from './dialogQueue';

/**
 * Do not import this directly, use `useDialog` instead.
 * This is for use in `DialogContainer` and `useDialog` only!
 */
export const DialogSystem: {
  removeDialog?: (id: string) => void;
  show?: (id: string, params: any[]) => Promise<unknown>;
  showQueued?: (id: string, params: any[], options?: DialogQueueOptions) => Promise<unknown>;
  hide?: (id: string) => Promise<void>;
  addDialog?: (id: string, component: Component, props: Record<string, any>) => void;
} = {};
